import { useCart } from "../contexts/CartContext";
import "../styles/CartPage.css";
import { useNavigate } from "react-router-dom";

const CartPage = () => {
    const { cartItems, removeFromCart, updateQuantity } = useCart();
    const total = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const navigate = useNavigate();

    const handleCheckout = () => {
        // Basit ödeme yönlendirmesi
        navigate("/payment", {
            state: {
                cartItems,
                total
            }
        });
    };

    return (
        <div className="cart-page">
            <div className="cart-container">
                <div className="cart-header">
                    <h1>🛒 Sepetiniz</h1>
                    <div className="cart-divider"></div>
                </div>

                {cartItems.length === 0 ? (
                    <div className="empty-cart">
                        <div className="empty-cart-icon">📦</div>
                        <h3>Sepetiniz boş</h3>
                        <p>Öğrenmeye başlamak için kurslarımıza ve kitaplarımıza göz atın!</p>
                        <div className="empty-cart-buttons">
                            <button className="browse-courses-btn" onClick={() => navigate("/courses")}>
                                <i className="fas fa-graduation-cap"></i>
                                Kurslara Göz At
                            </button>
                            <button className="browse-books-btn" onClick={() => navigate("/books")}>
                                <i className="fas fa-book"></i>
                                Kitaplara Göz At
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="cart-content">
                        {/* Ürün Listesi */}
                        <div className="cart-items-section">
                            <div className="cart-items">
                                {cartItems.map((item) => (
                                    <div key={item.id} className="cart-item">
                                        <div className="item-details">
                                            <h4>{item.title}</h4>
                                            <p className="item-description">{item.description || "Online kurs"}</p>
                                        </div>
                                        <div className="item-quantity">
                                            <label>Adet:</label>
                                            <input
                                                type="number"
                                                value={item.quantity}
                                                min="1"
                                                onChange={e => updateQuantity(item.id, parseInt(e.target.value))}
                                                className="quantity-input"
                                            />
                                        </div>
                                        <div className="item-price">
                                            <span className="unit-price">{item.price}₺</span>
                                            <span className="total-price">{(item.price * item.quantity).toFixed(2)}₺</span>
                                        </div>
                                        <button
                                            className="remove-btn"
                                            onClick={() => removeFromCart(item.id)}
                                            title="Sepetten Çıkar"
                                        >
                                            🗑️
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Sipariş Özeti */}
                        <div className="order-summary">
                            <h3>Sepet Özeti</h3>
                            <div className="summary-content">
                                <div className="summary-row">
                                    <span>Toplam {cartItems.length} ürün:</span>
                                    <span>{total.toFixed(2)}₺</span>
                                </div>
                                <div className="summary-divider"></div>
                                <div className="summary-row total-row">
                                    <span>Genel Toplam:</span>
                                    <span>{total.toFixed(2)}₺</span>
                                </div>
                                <button
                                    className="checkout-btn"
                                    onClick={handleCheckout}
                                >
                                    💳 Ödemeye Geç
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CartPage;
